"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetsServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const axios_1 = __importDefault(require("axios"));
class AssetsService extends client_1.RWSService {
    constructor() {
        super();
        this.storage = new Map();
        this.loading = new Map();
    }
    async getAsset(path) {
        // If already loaded, return from storage
        if (this.storage.has(path)) {
            return this.storage.get(path);
        }
        // If currently loading, wait for the existing promise
        if (this.loading.has(path)) {
            return await this.loading.get(path);
        }
        // Start loading the asset
        const loadingPromise = this.loadAsset(path);
        this.loading.set(path, loadingPromise);
        try {
            const result = await loadingPromise;
            return result;
        }
        finally {
            // Clean up the loading promise once completed
            this.loading.delete(path);
        }
    }
    async loadAsset(path) {
        const response = await axios_1.default.get(path);
        this.storage.set(path, response.data);
        return response.data;
    }
    async getStorage() {
        return this.storage;
    }
}
exports.AssetsServiceInstance = AssetsService;
exports.default = AssetsService.getSingleton();
